import { SxProps, Theme } from '@mui/material';

export const styledBoxSx: SxProps<Theme> = (theme) => ({
	'&.basic-border': {
		borderRadius: theme.shape.borderRadius,
		border: `2px solid ${theme.palette.grey[400]}`,
	},

	'&.expanded-menu-hover': {
		backgroundColor: theme.palette.primary.dark,
		cursor: 'pointer',
	},

	'&.accordion-show-expanded': { display: 'none' },
	'&.accordion-show-summary': { display: 'block' },

	// Accordion nested logic (matches `.Mui-expanded > &`)
	'.Mui-expanded > &': {
		'&.accordion-show-expanded': { display: 'none' },
		'&.accordion-show-summary': { display: 'block' },
	},

	'&.horizontal-scroll': {
		overflowX: 'auto',
		// maxWidth: window.innerWidth - parseInt(theme.spacing(3), 10),
	},
});
